export default __webpack_public_path__ + "static/0078-3c06557576dba69e298604b65d50f89e.png";